export default "__VITE_ASSET__DfxBRxBL__"